import { DateTime } from 'luxon'

const trendForResults = ({
  currentValue,
  previousValue,
  zeroToHundred = false
}) => {
  if (previousValue === null) {
    return 'noTrend'
  }
  let currentValueRounded = Math.round(currentValue * 10) / 10
  let previousValueRounded = Math.round(previousValue * 10) / 10
  if (zeroToHundred) {
    currentValueRounded = Math.round(currentValue)
    previousValueRounded = Math.round(previousValue)
  }
  const diffBuffer = 0.2 // zeroToHundred ? 0 : 0.89
  const diff = currentValueRounded - previousValueRounded
  if (diff !== null) {
    if (
      (diff >= 0 && diff <= diffBuffer) ||
      (diff < 0 && diff >= -diffBuffer)
    ) {
      return 'same'
    } else if (diff < 0) {
      return 'decreased'
    } else {
      return 'increased'
    }
  } else {
    return 'noTrend'
  }
}

export const getTrendDataForAverages = ({
  averages,
  regressionValues,
  zeroToHundred = false
}) => {
  try {
    const startDate = DateTime.fromISO(
      averages?.[0].date_modified
    ).toLocaleString(DateTime.DATE_SHORT)

    const endDate = DateTime.fromISO(
      averages?.[averages.length - 1].date_modified
    ).toLocaleString(DateTime.DATE_SHORT)

    const trend = trendForResults({
      currentValue: regressionValues[regressionValues.length - 1],
      previousValue: regressionValues[0],
      zeroToHundred
    })
    return {
      startDate,
      endDate,
      trend
    }
  } catch (error) {
    return null
  }
}

export const getTrendTextForStatItem = ({
  statItem,
  title = '',
  chartType,
  t,
  trendData = null
}) => {
  const td =
    trendData ||
    getTrendDataForAverages({
      averages: statItem.averages,
      regressionValues: statItem.regressionValues
    })
  if (td && statItem.regressionValues?.length > 1) {
    if (!title) {
      return t(`trendArrow.oldAndCurrent.tooltip.trend_${td.trend}`, {
        startDate: td.startDate,
        endDate: td.endDate
      })
    } else if (chartType === 'tag' || chartType === 'enps') {
      return t(`trendArrow.tag.tooltip.trend_${td.trend}`, {
        tagName: chartType === 'enps' ? title : title.toLowerCase(),
        startDate: td.startDate,
        endDate: td.endDate
      })
    } else {
      return t(`trendArrow.category.tooltip.trend_${td.trend}`, {
        categoryName: `"${title}"`,
        startDate: td.startDate,
        endDate: td.endDate
      })
    }
  } else {
    return t('trendArrow.noTrend')
  }
}
